import moment from 'moment'
import 'moment/min/locales.min'

import {
  REPEAT_RESULT,
  REPEAT_MONTHLY,
  WEEK_ORDER,
  REPEAT_BOOKING,
} from '../constants/repeatBooking'

export const getEveryType = (everyType) => {
  let isDaily = false
  let isWeekly = false
  let isMonthly = false
  let isYearly = false

  switch (everyType) {
    case 'day':
      isDaily = true
      break

    case 'week':
      isWeekly = true
      break

    case 'month':
      isMonthly = true
      break

    case 'year':
      isYearly = true
      break

    default:
      isWeekly = true
      break
  }

  return { isDaily, isWeekly, isMonthly, isYearly }
}

const weekOrder = {
  1: 'first',
  2: 'second',
  3: 'third',
  4: 'fourth',
}

export const getWeekOrder = (order) => {
  return weekOrder[order] || 'last'
}

export const getDayName = (dayOfWeek, language) => {
  return moment().day(dayOfWeek).locale(language.toLowerCase()).format('dddd')
}

export const getWeekly = (date) => {
  return moment(date).locale('en').format('dddd').toLowerCase()
}

export const getUnitDate = (selectedDate, language) => {
  return moment(selectedDate).locale(language.toLowerCase()).format('MMM DD, YYYY')
}

export const getUnitDateYear = (selectedDate, language) => {
  return moment(selectedDate).locale(language.toLowerCase()).format('MMMM DD')
}

export const getEndOnDate = (date) => {
  return moment(date)
}

export const getEndOnDateDefault = (date) => {
  return moment(date).add(3, 'months')
}

export const getSelectDate = (date) => {
  return moment(date).format('DD_MMMM').toLowerCase()
}

export const getMonthlyOptions = (date, language) => {
  const currentDate = moment(date)
  const dayName = currentDate.format('dddd')
  const weekOrder = Math.ceil(currentDate.date() / 7)
  const weekOrderFormatted = getWeekOrder(weekOrder)
  const weekOrderOption = WEEK_ORDER.find(({ key }) => key === weekOrderFormatted)[language]
  const dayNameText = language === 'EN' ? `${weekOrderOption} ${dayName}` : `${REPEAT_MONTHLY.AT.TH}${dayName}`

  const monthlyOptions = [
    {
      key: moment(date).format('DD'),
      value: `${REPEAT_MONTHLY.ON_DATE[language](moment(date).format('DD'))}`,
    },
    {
      key: `${weekOrderFormatted}_${dayName.toLowerCase()}`,
      value: `${REPEAT_MONTHLY.ON_DAY_NAME[language](dayNameText)}`,
    },
  ]

  return monthlyOptions
}

export const getRepeatResult = (data, language) => {
  if (data) {
    const {
      every,
      until,
      select: selectDates,
      occurrence: endOccurrence,
    } = data

    const isUntil = Boolean(until)

    const everyOccurrence = every[0]
    const everyType = every[1]
    const endDate = getUnitDate(until, language)

    switch (everyType) {
      case 'day':
        if (isUntil) {
          return `${REPEAT_RESULT.DAILY.UNTIL[language](everyOccurrence, endDate)}`
        } else {
          return `${REPEAT_RESULT.DAILY.AFTER[language](everyOccurrence, endOccurrence)}`
        }

      case 'week':
        const dayName = data.select.map((item) => getDayName(item, language)).join(', ')
        const isFullWeek = data.select.length === 7

        if (isFullWeek) {
          if (isUntil) {
            return `${REPEAT_RESULT.WEEKLY_All_DAYS.UNTIL[language](everyOccurrence, endDate)}`
          } else {
            return `${REPEAT_RESULT.WEEKLY_All_DAYS.AFTER[language](everyOccurrence, endOccurrence)}`
          }
        } else {
          if (isUntil) {
            return `${REPEAT_RESULT.WEEKLY.UNTIL[language](everyOccurrence, dayName, endDate)}`
          } else {
            return `${REPEAT_RESULT.WEEKLY.AFTER[language](everyOccurrence, dayName, endOccurrence)}`
          }
        }

      case 'month':
        const monthlyOptions = getMonthlyOptions(data.startDatetime, language)
        const isSelectByDate = Number(selectDates)

        const { key: dateOfMonth, value } = isSelectByDate ? monthlyOptions[0] : monthlyOptions[1]
        const startMonth = everyOccurrence === 1 ? value : dateOfMonth.replace('_', ' ')

        if (isUntil) {
          return `${REPEAT_RESULT.MONTHLY.UNTIL[language](everyOccurrence, startMonth, endDate)}`
        } else {
          return `${REPEAT_RESULT.MONTHLY.AFTER[language](everyOccurrence, startMonth, endOccurrence)}`
        }

      case 'year':
        const startYear = getUnitDateYear(data.until, language)  

        if(isUntil) {
          return `${REPEAT_RESULT.YEARLY.UNTIL[language](everyOccurrence, startYear, endDate)}`
        } else {
          return `${REPEAT_RESULT.YEARLY.AFTER[language](everyOccurrence, startYear, endOccurrence)}`
        }

      default: 
        return REPEAT_BOOKING.OFF[language]
    }
  } else {
    return REPEAT_BOOKING.OFF[language]
  }
}

export const getRecurrenceFormParams = (recurrenceData) => {
  const { isRepeat, option, isSelectedRepeatEndsOn, ...recurrence } = recurrenceData

  return recurrence
}
